import React from "react";
import api from "../../../../services/api";
import {
  calcularCriterio,
  fmtDateFull,
  fmtNum,
  todayISO,
} from "../../../../shared/utils";
function toBattlePayload(battle) {
  return {
    desafiante_id: Number(battle.desafiante_id),
    desafiado_id: Number(battle.desafiado_id),
    aposta: Number(battle.aposta),
    criterio: battle.criterio,
    criterio_label: battle.criterio_label,
    data_inicio: battle.data_inicio,
    data_fim: battle.data_fim,
    descricao: battle.descricao || "",
    status: battle.status,
    criado_em: Number(battle.criado_em) || Date.now(),
    vencedor_id: battle.vencedor_id ?? null,
    perdedor_id: battle.perdedor_id ?? null,
    val_desafiante: battle.val_desafiante ?? null,
    val_desafiado: battle.val_desafiado ?? null,
  };
}
export default function AdminDesafios(props) {
  const institutionContext = props.institutionContext;
  const institutionApi = institutionContext?.http || api;
  let batalhas = props.batalhas;
  let setBatalhas = props.setBatalhas;
  let students = props.students;
  let checkpoints = props.checkpoints;
  let checkpointsComAutomaticos = props.checkpointsComAutomaticos;
  let activities = props.activities;
  let showFlash = props.showFlash;
  const persistirBatalha = async function (
    battleId,
    payload,
    okMsg,
    tipo = "ok",
  ) {
    try {
      const responseData2 = await institutionApi.put(
        "/batalhas?id=".concat(battleId),
        toBattlePayload(payload),
      );
      const saved = responseData2.data?.data ?? responseData2.data;
      setBatalhas((prev) =>
        prev.map((prevId) => (prevId.id === battleId ? saved : prevId)),
      );
      showFlash(okMsg, tipo);
    } catch (err) {
      showFlash(
        err.response?.data?.message || "Nao foi possivel atualizar o desafio.",
        "er",
      );
    }
  };
  const hoje = todayISO();
  const ordenadas = [...batalhas].sort(
    (left, right) => Number(right.criado_em || 0) - Number(left.criado_em || 0),
  );
  const ativos = ordenadas.filter((ordenada) => "aceita" === ordenada.status);
  const renderBattleCard = (item) => {
    const student = students.find(
      (studentId) => studentId.id === item.desafiante_id,
    );
    const studentNome = students.find(
      (studentId) => studentId.id === item.desafiado_id,
    );
    const resultado = institutionContext
      ? Number(institutionContext.challengeMetrics?.[item.id]?.[0] || 0)
      : calcularCriterio(
          item.criterio,
          item.desafiante_id,
          item.data_inicio,
          "aceita" === item.status ? hoje : item.data_fim,
          checkpoints,
          activities,
          checkpointsComAutomaticos,
        );
    const resultadoAtual2 = institutionContext
      ? Number(institutionContext.challengeMetrics?.[item.id]?.[1] || 0)
      : calcularCriterio(
          item.criterio,
          item.desafiado_id,
          item.data_inicio,
          "aceita" === item.status ? hoje : item.data_fim,
          checkpoints,
          activities,
          checkpointsComAutomaticos,
        );
    const encerrado = item.data_fim < hoje;
    const podeEditar = "aguardando" === item.status || "aceita" === item.status;
    return (
      <div
        className={"fc"}
        style={{
          marginBottom: 10,
        }}
        key={item.id}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: 6,
            gap: 8,
          }}
        >
          <div>
            <div
              style={{
                fontWeight: 700,
                color: "#1F4754",
                fontSize: 14,
              }}
            >
              {student?.nome || "Aluno removido"}
              {" vs "}
              {studentNome?.nome || "Aluno removido"}
            </div>
            <div
              style={{
                fontSize: 12,
                color: "#6B8590",
                marginTop: 3,
              }}
            >
              {item.criterio_label}
              {" - "}
              {fmtNum(item.aposta)}
              {" tokens cada"}
            </div>
            <div
              style={{
                fontSize: 12,
                color: "#6B8590",
              }}
            >
              {"Inicio: "}
              {fmtDateFull(item.data_inicio)}
            </div>
            <div
              style={{
                fontSize: 12,
                color: "#6B8590",
              }}
            >
              {"Fim: "}
              {fmtDateFull(item.data_fim)}
            </div>
          </div>
          <span
            style={{
              fontSize: 10,
              fontWeight: 700,
              color:
                "aceita" === item.status
                  ? encerrado
                    ? "#B83A2E"
                    : "#1A7A6E"
                  : "#1F4754",
              background:
                "aceita" === item.status
                  ? encerrado
                    ? "#FFE5E0"
                    : "#E0F5F0"
                  : "#F4F8F9",
              padding: "3px 8px",
              borderRadius: 999,
              textTransform: "uppercase",
            }}
          >
            {item.status}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            gap: 6,
          }}
        >
          <div
            style={{
              flex: 1,
              background:
                resultado > resultadoAtual2
                  ? "#E0F5F0"
                  : resultado === resultadoAtual2
                    ? "#F4F8F9"
                    : "#FFE5E0",
              borderRadius: 8,
              padding: "8px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: 11,
                color: "#6B8590",
                marginBottom: 2,
              }}
            >
              {student?.nome?.split(" ")[0] || "Aluno 1"}
            </div>
            <div
              style={{
                fontSize: 20,
                fontWeight: 800,
                color:
                  resultado > resultadoAtual2
                    ? "#1A7A6E"
                    : resultado === resultadoAtual2
                      ? "#1F4754"
                      : "#B83A2E",
              }}
            >
              {fmtNum(resultado, 1)}
            </div>
          </div>
          <div
            style={{
              flex: 1,
              background:
                resultadoAtual2 > resultado
                  ? "#E0F5F0"
                  : resultado === resultadoAtual2
                    ? "#F4F8F9"
                    : "#FFE5E0",
              borderRadius: 8,
              padding: "8px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: 11,
                color: "#6B8590",
                marginBottom: 2,
              }}
            >
              {studentNome?.nome?.split(" ")[0] || "Aluno 2"}
            </div>
            <div
              style={{
                fontSize: 20,
                fontWeight: 800,
                color:
                  resultadoAtual2 > resultado
                    ? "#1A7A6E"
                    : resultado === resultadoAtual2
                      ? "#1F4754"
                      : "#B83A2E",
              }}
            >
              {fmtNum(resultadoAtual2, 1)}
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            gap: 7,
            marginTop: 8,
            flexWrap: "wrap",
          }}
        >
          {podeEditar && (
            <button
              type={"button"}
              className={"btn bd"}
              style={{
                flex: 1,
                fontSize: 12,
              }}
              onClick={() =>
                (async (battle) => {
                  await persistirBatalha(
                    battle.id,
                    {
                      ...battle,
                      status: "cancelada",
                    },
                    "Desafio cancelado pelo admin.",
                    "in",
                  );
                })(item)
              }
            >
              {"Cancelar"}
            </button>
          )}
          {"aceita" === item.status && (
            <button
              type={"button"}
              className={"btn"}
              style={{
                flex: 1,
                fontSize: 12,
              }}
              onClick={() =>
                (async (battle, index, indexItem) => {
                  const empate = index === indexItem;
                  const vencedorId = empate
                    ? null
                    : index > indexItem
                      ? battle.desafiante_id
                      : battle.desafiado_id;
                  const perdedorId = empate
                    ? null
                    : index > indexItem
                      ? battle.desafiado_id
                      : battle.desafiante_id;
                  await persistirBatalha(
                    battle.id,
                    {
                      ...battle,
                      status: empate ? "empate" : "finalizada",
                      vencedor_id: vencedorId,
                      perdedor_id: perdedorId,
                      val_desafiante: index,
                      val_desafiado: indexItem,
                    },
                    empate
                      ? "Desafio encerrado com empate."
                      : "Desafio encerrado com vencedor definido.",
                    "ok",
                  );
                })(item, resultado, resultadoAtual2)
              }
            >
              {"Encerrar agora"}
            </button>
          )}
          {!institutionContext && (
            <button
              type={"button"}
              className={"btn bd"}
              style={{
                flex: 1,
                fontSize: 12,
                color: "#B83A2E",
                borderColor: "#F0B0A8",
              }}
              onClick={() =>
                (async (battle) => {
                  try {
                    await institutionApi.delete(
                      "/batalhas?id=".concat(battle.id),
                    );
                    setBatalhas((prev) =>
                      prev.filter((prevId) => prevId.id !== battle.id),
                    );
                    showFlash("Desafio excluído pelo admin.", "in");
                  } catch (err) {
                    showFlash(
                      err.response?.data?.message ||
                        "Nao foi possivel excluir o desafio.",
                      "er",
                    );
                  }
                })(item)
              }
            >
              {"Excluir"}
            </button>
          )}
        </div>
      </div>
    );
  };
  return (
    <div>
      <div className={"dv dv-dark"}>
        <span>
          {"Desafios em Andamento ("}
          {ativos.length}
          {")"}
        </span>
      </div>
      {0 === ativos.length ? (
        <p
          style={{
            color: "rgba(255,255,255,0.6)",
            textAlign: "center",
            padding: 14,
            fontSize: 13,
          }}
        >
          {"Nenhum desafio ativo."}
        </p>
      ) : (
        ativos.map(renderBattleCard)
      )}
      <div
        className={"dv dv-dark"}
        style={{
          marginTop: 18,
        }}
      >
        <span>
          {"Todos os Desafios ("}
          {ordenadas.length}
          {")"}
        </span>
      </div>
      {0 === ordenadas.length ? (
        <p
          style={{
            color: "rgba(255,255,255,0.6)",
            textAlign: "center",
            padding: 14,
            fontSize: 13,
          }}
        >
          {"Nenhum desafio cadastrado."}
        </p>
      ) : (
        ordenadas.map(renderBattleCard)
      )}
    </div>
  );
}
export { AdminDesafios };
